import { createContext } from "react";

export interface ITransactionInfo {
  id: number;
  finished_at: string | null;
}

export interface IContactInfo {
  phoneNumbers: string[];
  emails: string[];
  mostRecentPhoneRequestTransaction: ITransactionInfo | null;
  mostRecentEmailRequestTransaction: ITransactionInfo | null;
}

interface IContactInfoContext {
  contactInfo: { [orgContactId: number]: IContactInfo };
  updateContactPhoneNumbersBatch: ({
    contactUpdates,
  }: {
    contactUpdates: {
      orgContactId: number;
      phoneNumbers: string[];
      transaction: ITransactionInfo;
    }[];
  }) => void;
  updateContactEmailsBatch: ({
    contactUpdates,
  }: {
    contactUpdates: {
      orgContactId: number;
      emails: string[];
      transaction: ITransactionInfo;
    }[];
  }) => void;
  getContactInfo: (orgContactId: number) => IContactInfo | null;
}

const ContactInfoContext = createContext<IContactInfoContext>({
  contactInfo: {},
  updateContactPhoneNumbersBatch: () => {},
  updateContactEmailsBatch: () => {},
  getContactInfo: () => null,
});

export default ContactInfoContext;
